<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div class="page-wrapper">
      <div class="page-breadcrumb">
        <p class="font-14 font-weight-bold">
          {{ singlegroup.group.name }}
        </p>
        <div class="row">
          <div class="col-sm-8 col-lg-8 align-self-center col-12">
            <ul class="breadcrumb mb-2 list-style-none">
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/groups/' + this.$route.params.id + '/overview'"
                  >{{ $t("overview") }}</router-link
                >
              </li>
              <!-- <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/groups/' + this.$route.params.id + '/group-chart'"
                  >{{ $t("chart") }}</router-link
                >
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/groups/' + this.$route.params.id + '/records'"
                  >{{ $t("records") }}</router-link
                >
              </li> -->
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/groups/' + this.$route.params.id + '/devices'"
                  >{{ $t("devices") }}</router-link
                >
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                v-show="profile.role !== 'staff'"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/groups/' + this.$route.params.id + '/users'"
                  >{{ $t("users") }}</router-link
                >
              </li>
              <li
                v-show="profile.role !== 'staff'"
                class="breadcrumb-item h6 font-16 mylink"
                v-if="canPerformAction('groups', 'edit')"
              >
                <router-link
                  class="mylink"
                  :to="'/groups/' + this.$route.params.id + '/settings'"
                  >{{ $t("settings") }}</router-link
                >
              </li>
            </ul>
          </div>
          <div class="col-sm-4 col-lg-4 align-self-center col-12">
            <button
              class="btn d-block ml-auto"
              :class="
                this.$route.name == 'GroupSettings'
                  ? 'btn-outline-danger'
                  : 'btn-primary'
              "
              @click="btnClicked"
              v-if="btnLabel"
            >
              {{ btnLabel }}
            </button>
          </div>
        </div>
      </div>

      <router-view
        @getSingleDevice="getSingleDevice"
        :title="singlegroup.group.name"
        :showModal="showModal"
        @close_modal="showModal = null"
      />

      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ViewGroup",
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      // singlegroup: {},
      showModal: null,
    };
  },
  mounted() {
    this.updatePageNumber({
      lastPageNumber: 1,
      lastPage: "",
      lastPageName: this.$t("group"),
      // lastPageName: "group",
      lastPageLink: "/groups",
    });

    this.fetchSingleGroup({ id: this.$route.params.id })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          //console.log(error.response);
          this.$router.push("/404");
        }
      });

    this.fetchSingleGroupDevices({ id: this.$route.params.id });
    this.fetchSingleGroupUsers({ id: this.$route.params.id }).then(() => {});
    this.fetchSingleGroupOverview({ id: this.$route.params.id }).then(() => {});
  },
  computed: {
    ...mapGetters([
      "profile",
      "singlegroupId",
      "singlegroup",
      "canPerformAction",
    ]),
    btnLabel() {
      let label = "";
      if (
        this.$route.name == "GroupDevices" &&
        this.canPerformAction("groups", "add")
      )
        label = "Add Device";
      if (
        this.$route.name == "GroupUsers" &&
        this.canPerformAction("groups", "add")
      )
        label = "Add User";
      if (
        this.$route.name == "GroupSettings" &&
        this.canPerformAction("groups", "edit")
      )
        label = "Delete Group";
      return label;
    },
  },
  methods: {
    ...mapActions([
      "fetchSingleGroup",
      "fetchSingleGroupOverview",
      "fetchSingleGroupUsers",
      "fetchSingleGroupDevices",
      "fetchSingleGroupStats",
      "updatePageNumber",
    ]),
    getSingleDevice(type) {
      this.isLoading = true;
      if (type === "device")
        return this.fetchSingleGroupDevices({
          id: this.$route.params.id,
        }).then(() => {
          this.isLoading = false;
        });
      else {
        this.fetchSingleGroupUsers({ id: this.$route.params.id }).then(() => {
          this.isLoading = false;
        });
      }
    },
    btnClicked() {
      // console.log(this.$route);
      // console.log(this, "this");
      this.showModal = this.$route.name;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.updatePageNumber({
      lastPageNumber: 1,
      lastPage: "",
      lastPageName: "",
      lastPageLink: "",
    });
    next();
  },
};
</script>

<style scoped>
.mylink {
  color: #5e6a79 !important;
  text-underline-offset: 5px;
  font-size: 14px !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
  font-weight: 700;
}
.router-link-exact-active,
.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  font-weight: 700;
}
.router-link-exact-active {
  cursor: default;
}
</style>
